import {
  DC_Products_Client_Old_Client_Models_BuildingCategory,
  DC_Products_Client_Old_Client_Models_BuildingSubCategory,
  DC_Products_Client_Old_Client_Models_ConstructionPeriod,
  DC_Products_Client_Old_Client_Models_CurrentHeatingSystem,
  DC_Products_Client_Old_Client_Models_FloorAreaM2,
  DC_Products_Client_Old_Client_Models_NumberFloors,
  DC_Repositories_Base_Enumerations_BusinessUnit,
  DC_Repositories_Base_Enumerations_Label,
  ResponseDataListDC_Products_Client_Old_Client_Models_DecarbPotential,
} from '@monorepo-types/dc';

import { request } from '../client';
import type { ApiRequestConfig } from '../client/types';

type GetDecarbonizationPotentials = {
  businessUnit: DC_Repositories_Base_Enumerations_BusinessUnit;
  label: DC_Repositories_Base_Enumerations_Label;
  buildingCategory: DC_Products_Client_Old_Client_Models_BuildingCategory;
  buildingSubCategory: DC_Products_Client_Old_Client_Models_BuildingSubCategory;
  floorAreaM2: DC_Products_Client_Old_Client_Models_FloorAreaM2;
  numberOfFloors: DC_Products_Client_Old_Client_Models_NumberFloors;
  constructionPeriod: DC_Products_Client_Old_Client_Models_ConstructionPeriod;
  currentHeatingSystem: DC_Products_Client_Old_Client_Models_CurrentHeatingSystem;
  solarPanelsInstalled: boolean;
  roofIsolationInstalledWithinLast10Years: boolean;
};
/**
 * Get the decarbonization calculation for some building
 *
 * @returns ResponseDataListDC_Products_Client_Old_Client_Models_DecarbPotential Success
 */
export function getDecarbonizationPotentials(
  {
    businessUnit,
    label,
    buildingCategory,
    buildingSubCategory,
    floorAreaM2,
    numberOfFloors,
    constructionPeriod,
    currentHeatingSystem,
    solarPanelsInstalled,
    roofIsolationInstalledWithinLast10Years,
  }: GetDecarbonizationPotentials,
  requestConfig: ApiRequestConfig = {},
): Promise<ResponseDataListDC_Products_Client_Old_Client_Models_DecarbPotential> {
  return request(
    {
      method: 'GET',
      path: `/dxpweb/public/${businessUnit}/${label}/decarbonization/potentials`,
      query: {
        buildingCategory,
        buildingSubCategory,
        floorAreaM2,
        numberOfFloors,
        constructionPeriod,
        currentHeatingSystem,
        solarPanelsInstalled,
        roofIsolationInstalledWithinLast10Years,
      },
      errors: { 400: 'Bad Request' },
    },
    requestConfig,
  );
}
